import React from "react";
import { PatternFormat } from "react-number-format";
import { useState, useEffect } from "react";
import api from "../../services/api";

const Cep = props => {
  const { value, valueChange, disabled, required, loadData } = props;
  const [isValid, setisValid] = useState(false);
  const invalidate = () => {
    setisValid(false);
    return false;
  };
  useEffect(() => {
    if (value) {
      (async () => {
        let _is_valid = String(value || 0)?.length === 8;
        if (!_is_valid) return invalidate();
        try {
          const { data: _cep_data } = await api.get(`https://viacep.com.br/ws/${value}/json/`);
          // if (!!_cep_data.erro) {
          //   toast.error("CEP Inválido.", { toastId: "cep_error" });
          //   return invalidate();
          // }
          if (!!loadData && !_cep_data.erro) {
            let _state = loadData?.states?.find(e => e.uf === _cep_data?.uf);
            let { data: _cities } = await api.get(`cities/${_state.value}`);
            let _city = _cities.find(e => e.name === _cep_data.localidade) || null;
            loadData.afterSuccess({
              address: _cep_data.logradouro,
              district: _cep_data.bairro,
              city_id: _city.id,
              state_id: _city.state_id,
            });
          }
        } catch (__error) {
          console.log("__error", __error);
        } finally {
          setisValid(true);
        }
      })();
    }
    // Only re-runs when `value` (the typed CEP) changes; `loadData` is passed inline from the
    // parent and can get a new reference every render, so including it would re-trigger the
    // lookup request unnecessarily.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  return (
    <PatternFormat
      data-required={required}
      data-required-valid={required && !!isValid}
      disabled={disabled}
      placeholder="*****-***"
      format="#####-###"
      value={!value ? "" : value}
      onValueChange={__ev => {
        valueChange(String(__ev.value));
      }}
      onKeyPress={__ev => {
        __ev.key === "Enter" && __ev.target.blur();
      }}
      {...props}
    />
  );
};

export default Cep;
